/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/common';
import * as import2 from '../../../app/pagination/pagination.component';
const styles_DsPaginationComponent:any[] = ([] as any[]);
export const RenderType_DsPaginationComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_DsPaginationComponent,
  data: {}
}
);
function View_DsPaginationComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.changePage(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import0.ɵpad(1),
    (l()(),import0.ɵted((null as any),[
      '\n   ',
      '\n  '
    ]
    ))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ((co.current == v.context.$implicit)? ck(v,2,0,'active'): import0.ɵEMPTY_ARRAY);
    ck(v,1,0,currVal_0);
  },(ck,v) => {
    const currVal_1:any = v.context.$implicit;
    ck(v,3,0,currVal_1);
  });
}
export function View_DsPaginationComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),16,'div',[[
        'class',
        'ds-pagination'
      ]
      ],[[
        8,
        'id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n  '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import2.DsPaginationComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.firstPage()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['«'])),
    (l()(),import0.ɵted((null as any),['\n  '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import2.DsPaginationComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.previousPage()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['‹'])),
    (l()(),import0.ɵted((null as any),['\n  '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DsPaginationComponent_1)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n  '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import2.DsPaginationComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.nextPage()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['›'])),
    (l()(),import0.ɵted((null as any),['\n  '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import2.DsPaginationComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.lastPage()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['»'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import2.DsPaginationComponent = v.component;
    const currVal_1:any = co.pages;
    ck(v,9,0,currVal_1);
  },(ck,v) => {
    var co:import2.DsPaginationComponent = v.component;
    const currVal_0:any = import0.ɵinlineInterpolate(1,'',co.id,'');
    ck(v,0,0,currVal_0);
  });
}
function View_DsPaginationComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'ds-pagination',([] as any[]),(null as any),(null as any),(null as any),View_DsPaginationComponent_0,RenderType_DsPaginationComponent)),
    import0.ɵdid(114688,(null as any),0,import2.DsPaginationComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const DsPaginationComponentNgFactory:import0.ComponentFactory<import2.DsPaginationComponent> = import0.ɵccf('ds-pagination',import2.DsPaginationComponent,View_DsPaginationComponent_Host_0,{
  current: 'current',
  id: 'id',
  max: 'max',
  limit: 'limit'
}
,{pageChange: 'pageChange'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/pagination/pagination.component.ngfactory.ts